import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { InternalStateHelperService } from '../internal-state/internal-state.helper.service';
import { CoreEffects } from '../../../state/effect/core.effects';

@Injectable()
export class KeysDefaultBehavior {

    constructor(
        protected coreEffects: CoreEffects,
        private stateHelper: InternalStateHelperService,
        private location: Location
    ) { }

    focusLinearly(index, component) {
        if (component.data && index >= 0 && index < component.data.length) {
            let target = component.data[index];
            if (target) {
                if (component['virtualPageSize']) {
                    if (component.isFlattened) {
                        this.stateHelper.adjustScopeItemsInFlattenedRow(component, index)
                    } else {
                        this.stateHelper.adjustInScopeItems(component, index);
                    }
                }
                component.focusedItem = target;
                component.focusedItemIndex = index;
                return true;
            }
        }
        return false;
    }


    focusVertically(currentIndex, direction, component) {
        if (component.interactionMode !== component.TraversalModes.Grid) {
            return this.focusLinearly(currentIndex + direction, component)
        }

        //calculate vertical amount to traverse
        let currentRow = Math.ceil((currentIndex + 1) / component.maxPerRow)
        let targetRow = currentRow + direction;
        if (targetRow > 0 && targetRow <= component.numberOfRows) {
            let targetIndex = currentIndex + (component.maxPerRow * direction);
            let lastIndex = component.data.length - 1;
            let matchIndex = targetIndex > lastIndex ? lastIndex : targetIndex
            if (component.data && component.data[matchIndex]) {
                component.focusedItem = component.data[matchIndex];
                component.focusedItemIndex = matchIndex;
                if (component['virtualPageSize']) {
                    this.stateHelper.adjustInScopeItems(component, component.focusedItemIndex);
                }
                return true;
            }
            else {
                component.focusedItemIndex = matchIndex;
                component.focusedItem = matchIndex;
            }
        }
        return false;
    }



    handleNavigationKey(keyCode, component) {
        var handled = false;

        // process key and set result
        if (component.isActive) {
            var currIndex = component.focusedItemIndex >= 0 ? component.focusedItemIndex : component.data.indexOf(component.focusedItem);
            var previousFocusedItem = component.focusedItem ? component.focusedItem.meta_slug : null;
            switch (keyCode) {
                case component.KeyCode.UP:
                    handled = this.focusVertically(currIndex, -1, component)
                    break;
                case component.KeyCode.DOWN:
                    handled = this.focusVertically(currIndex, 1, component);
                    break;
                case component.KeyCode.RIGHT:
                    handled = this.focusLinearly(currIndex + 1, component);
                    break;
                case component.KeyCode.LEFT:
                    handled = this.focusLinearly(currIndex - 1, component);
                    break;
            }

            //             if(component.isFiltered){
            //                 //this.stateHelper.handleFilterRowFocusChanged(component,previousFocusedItem);
            //                 component.dispatchFilterControllerUpdate();
            //             }
        }



        //if directional key was handled, a focus change occurred and
        //a scroll request will be expected from the new focused item.
        //component.awaitScrollRequest = handled;
        component.ref.detectChanges();
        // set 'handled = true' if key is handled, otherwise set to 'false'
        if (handled && component['slug']) {
            this.stateHelper.setDescendantSelected(component['slug'], component.focusedItemIndex);
        }
        if (handled){
            if (component['autoclose']){
                component['autoclose'] = false;
            }
        }
        return handled;
    }

    handleSelect(keyCode, component) {
        const target = component.focusedItem.meta || component.focusedItem;
        if (target) {
            if (component.interactionOnSelect) {
                component.eventInteractions.next({ key: component.interactionOnSelect, message: target });
                return true;
            }

            switch ((target.obj_type || "").toLowerCase()) {
                case 'place':
                case 'profile':
                case 'series profile':
                case 'event':
                case 'page':
                case 'series':
                case 'video':
                case 'episode':
                case 'stream':
                case 'curatedlist':
                    if (target.internal_route) {
                        //navigate
                        if (["Episode", "Video"].indexOf(target.obj_type) > -1) {
                            let video = target.video || target;
                            let meta = video.meta || video;
                            if (meta.percent_played < 1 && target.internal_route_timestamped) { //only allow if play not completed
                                component.router.navigateByUrl(target.internal_route_timestamped);
                                return true;
                            }
                        }

                        component.router.navigateByUrl(target.internal_route);
                        return true;
                    }
                    break
                case "notification":
                    if (target.item && target.item.internal_route) {
                        component.router.navigateByUrl(target.item.internal_route)
                        return true
                    }
                    break
            }
        }
        return false;
    }

    handleBack(keyCode, component) {
        //default back handle will refocus to first item in set
        if (component.focusedItemIndex != 0) {
            //component.awaitScrollRequest = true;
            this.resetComponentDefaultFocusedItem(component);
            component.ref.detectChanges();
            return true;
        }
        return false;
    }

    resetComponentDefaultFocusedItem(component) {
        if (component.data) {
            this.focusLinearly(0, component);
        }
        else {
            component.focusedItemIndex = 0;
        }
        if (component['slug']) {
            this.stateHelper.setDescendantSelected(component['slug'], 0);
        }
    }

    handleAppBack() {
        let result = false;
        const history = [].concat(this.stateHelper.getActivePathHistory());
        if (history.length > 0) {
            const res = history[0].urlKey;
            this.stateHelper.setPopState(res);
            this.location.back();
            result = true;
        }
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/input-devices/keys.default.behavior.service.ts